import { useDroppable } from '@dnd-kit/core';
import { matchDropzoneInput } from '@utils/component-framework';
import { usePageContext } from '../../../../context.js';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useInputState } from '../../hook.use-input-state.js';
import { DraggableTile } from './atom.draggable.js';
import { Dropzone } from './atom.dropzone/_dropzone.js';
import { MatchTile } from './atom.tile.js';
import { jsx } from 'react/jsx-runtime';

function MatchDropzone(props) {
  const pageContext = usePageContext();
  const {
    setNodeRef,
    isOver
  } = useDroppable({
    id: props.dropzone.id,
    disabled: !props.draggable
  });
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => matchDropzoneInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.dropzone.id])
  });
  const tileWithinId = props.facitType === "should-have" ? props.dropzone.validation.acceptedTileIds[0] : inputEntry?.tileId;
  const tileWithin = tileWithinId ? props.tiles.find(it => it.id === tileWithinId) : undefined;
  const state = useInputState(props.dropzone, inputEntry);
  const tileState = props.facitType === "user-entry" ? state : props.dropzone.validation.acceptedTileIds[0] === inputEntry?.tileId ? "correct" : "should-have";
  return /*#__PURE__*/jsx(Dropzone, {
    content: props.dropzone,
    dropzoneRef: setNodeRef,
    isDraggingOverDropzone: isOver,
    standaloneImageDropzone: props.dropzoneType === "standalone-image",
    state: state === "input" ? "interactive" : "static",
    theme: pageContext !== "print" && state === "input" ? "white" : "dimmed",
    children: tileWithin && (props.draggable ? /*#__PURE__*/jsx(DraggableTile, {
      tile: tileWithin,
      context: "dropzone",
      state: tileState,
      taskEntryKey: props.taskEntryKey,
      isDraggingItem: props.draggedItemId === tileWithin.id
    }, tileWithinId) : /*#__PURE__*/jsx(MatchTile, {
      context: "dropzone",
      taskEntryKey: props.taskEntryKey,
      tile: tileWithin,
      state: tileState
    }, tileWithinId))
  });
}

export { MatchDropzone };
//# sourceMappingURL=input.dropzone.js.map
